export const SET_HPOOL_TOKENS_LIST = 'SET_HPOOL_TOKENS_LIST'
export const SET_CURRENT_HPOOL_TOKEN = 'SET_CURRENT_HPOOL_TOKEN'
export const SET_LATEST_TRADE_PRICE = 'SET_LATEST_TRADE_PRICE'
